import React, { useEffect } from "react";
import { brandColors } from "../../../lib/color";
import CloseButton from "../../elements/CloseButton/CloseButton";
import * as styles from "./LoginDrawer.module.css";
import { Equals } from "../../elements/Equals/equals";
import { LoginForm, LoginForms } from "../../blocks/LoginForm/LoginForm";

interface Props {
  open: boolean;
  setLoginOpen: Function;
  forms: LoginForms;
}

export const LoginDrawer: React.FC<Props> = ({ open, setLoginOpen, forms }) => {
  const handleCloseClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setLoginOpen(false);
  };

  useEffect(() => {
    function handleWindowClick(event: MouseEvent) {
      const clickedEl = event.target as HTMLElement;
      if (
        !clickedEl?.closest(".js-login-drawer") &&
        open &&
        !clickedEl?.closest(".js-login-close")
      ) {
        setLoginOpen(false);
      }
    }
    window.addEventListener("click", handleWindowClick, true);

    return function cleanup() {
      window.removeEventListener("click", handleWindowClick, true);
    };
  }, [open]);

  useEffect(() => {
    if (open === true) {
      document.getElementById("drawerdigbank_userId")?.focus();
    }
  }, [open]);

  return (
    <div
      className={`${styles.container} ${
        open ? styles.open : ""
      } js-login-drawer`}
    >
      <CloseButton
        color={brandColors.medgray}
        className={`${styles.closeBtn} js-login-close`}
        onClick={handleCloseClick}
      />
      <div>
        <Equals className={styles.equals} id="welcomeEquals" />
        <h2 className={styles.welcome}>Welcome back.</h2>
        {forms && (
          <LoginForm
            forms={forms}
            id="drawer-login-form"
            style="dark"
            prefix="drawer"
          />
        )}
      </div>
    </div>
  );
};
